module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (181).9d0fb331.jpg";